omadapp.components.quizz_answer_with_feedback = function($context,data,callback) {
	var t = this
	var $ = jQuery
	t.data =  data
	t.$context = $context
	t.callback = callback

	t.initialize = initialize
	t.resolve = resolve

	var $js_feedback = $context.find(".js_feedback")
	
	t.inherit = omadapp.controllers.scenes.common_methods.heredar
	t.inherit(omadapp.components.common_answers_methods)

	t.initialize()


    function initialize() {
    	t.super.initialize.call(t)

    	$js_feedback.addClass("hidden")
    	$js_feedback.html(t.data.feedback)
    }

    function resolve () {
    	t.super.resolve.call(t)
    	$js_feedback.removeClass("hidden")
    }

}